// styling is incomplete
// Respective social links have to be added

import React from 'react';
import Card from 'react-bootstrap/Card';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Footer.css';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import { Grid } from '@mui/material';

export default function Footer() {
    return (
        <Card  className='custom-style'>
  <Card.Footer>
  <Card.Body sx={{display:"flex",flexDirection:'row'}}>
  <Grid item lg={6} align='left'>
  <Card.Title>Bangalore Institute of Technology</Card.Title>
    <Card.Text>
    K.R. Road, V V Pura,<br></br>
    Bengaluru-560004,<br></br>
    India.
    </Card.Text>
  </Grid>
    <Grid item lg={12} align='right'>
    {/* <Card.Body> */}
    <Card.Link href="https://www.instagram.com/bitsince1979/"><InstagramIcon  sx={{ color:"white"  ,fontSize:40, align:'right' }}/></Card.Link>
    <Card.Link href="https://www.youtube.com/bitsince1979"><YouTubeIcon sx={{ color:"white" ,fontSize:40, align:'right' }}/></Card.Link>
    <Card.Link href="https://www.facebook.com/bitsince1979"><FacebookIcon sx={{ color:"white" ,fontSize:40, align:'right' }}/></Card.Link>
    <Card.Link href="https://twitter.com/bitsince1979"><TwitterIcon sx={{ color: "white" ,fontSize:40, align:'right' }}/></Card.Link>
    {/* </Card.Body> */}
    </Grid>
    </Card.Body>
    
  
  </Card.Footer>
</Card>
            
        
    )
}
